import Pagination from 'react-bootstrap/Pagination'
import { Iprops } from './type'
import './index.css'

const CustomPagination = ({
    totalPages,
    currentPage,
    getPageNumber,
}: Iprops) => {
    const items = []

    for (let number = 1; number <= totalPages; number++) {
        items.push(
            <Pagination.Item
                key={number}
                active={number == currentPage}
                onClick={() => getPageNumber(number)}
            >
                {number}
            </Pagination.Item>
        )
    }

    return (
        <>
            <Pagination className="d-flex justify-content-center">
                <Pagination.Prev
                    disabled={currentPage <= 1}
                    onClick={() => getPageNumber(currentPage - 1)}
                />
                {items}
                <Pagination.Next
                    onClick={() => getPageNumber(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                />
            </Pagination>
        </>
    )
}

export default CustomPagination
